'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Chip = undefined;

var _templateObject = _taggedTemplateLiteral(['\n\t\t\tbackground-color: #fff;\n\t\t\tborder: 1px solid ', ';\n\t\t\tcolor: ', ';\n\n\t\t\tsvg {\n\t\t\t\tfill: ', ';\n\t\t\t}\n\t\t'], ['\n\t\t\tbackground-color: #fff;\n\t\t\tborder: 1px solid ', ';\n\t\t\tcolor: ', ';\n\n\t\t\tsvg {\n\t\t\t\tfill: ', ';\n\t\t\t}\n\t\t']),
    _templateObject2 = _taggedTemplateLiteral(['\n\t\tbackground-color: ', ';\n\t\tborder: 1px solid ', ';\n\t\tcolor: ', ';\n\n\t\t> .icon-btn:hover {\n\t\t\tbackground-color: ', ';\n\t\t}\n\n\t\tsvg {\n\t\t\tfill: ', ';\n\t\t}\n\t'], ['\n\t\tbackground-color: ', ';\n\t\tborder: 1px solid ', ';\n\t\tcolor: ', ';\n\n\t\t> .icon-btn:hover {\n\t\t\tbackground-color: ', ';\n\t\t}\n\n\t\tsvg {\n\t\t\tfill: ', ';\n\t\t}\n\t']),
    _templateObject3 = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tborder-radius: 15px;\n\theight: 30px;\n\n\t', '\n\n\t> .label {\n\t\tfont-size: 14px;\n\t\tpadding: 0 3px 0 10px;\n\n\t\t&:only-child {\n\t\t\tpadding: 0 10px;\n\t\t}\n\t}\n\n\t> .icon-btn {\n\t\theight: 30px;\n\t\twidth: 30px;\n\t\tborder-radius: 15px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcursor: pointer;\n\n\t\t> svg {\n\t\t\theight: 14px;\n\t\t\twidth: 14px;\n\t\t}\n\t}\n'], ['\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tborder-radius: 15px;\n\theight: 30px;\n\n\t', '\n\n\t> .label {\n\t\tfont-size: 14px;\n\t\tpadding: 0 3px 0 10px;\n\n\t\t&:only-child {\n\t\t\tpadding: 0 10px;\n\t\t}\n\t}\n\n\t> .icon-btn {\n\t\theight: 30px;\n\t\twidth: 30px;\n\t\tborder-radius: 15px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcursor: pointer;\n\n\t\t> svg {\n\t\t\theight: 14px;\n\t\t\twidth: 14px;\n\t\t}\n\t}\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _Close = require('./icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _Add = require('./icons/Add');

var _Add2 = _interopRequireDefault(_Add);

var _ChevronDown = require('./icons/ChevronDown');

var _ChevronDown2 = _interopRequireDefault(_ChevronDown);

var _globals = require('../globals');

var _globals2 = _interopRequireDefault(_globals);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColor = _utils2.default.getColor,
    getDarkenedColor = _utils2.default.getDarkenedColor,
    getLightenedColor = _utils2.default.getLightenedColor;


var chipMixin = function chipMixin(props) {
	var primary = props.primary,
	    success = props.success,
	    filled = props.filled,
	    color = props.color;


	if (color) {
		return (0, _styledComponents.css)(_templateObject, color, color, color);
	}

	var baseColor = _globals2.default.colors.cloud;
	var bgColor = baseColor;
	var fgColor = '#5a6c7d';
	var borderColor = 'transparent';
	var hoverColor = (0, _polished.darken)(0.05, baseColor);

	if (primary || success) {
		fgColor = getDarkenedColor(props);

		if (filled) {
			bgColor = getLightenedColor(props);
			hoverColor = (0, _polished.darken)(0.1, bgColor);
		} else {
			bgColor = '#fff';
			hoverColor = getLightenedColor(props);
			borderColor = getColor(props);
		}
	}

	return (0, _styledComponents.css)(_templateObject2, bgColor, borderColor, fgColor, hoverColor, fgColor);
};

var StyledChip = _styledComponents2.default.div(_templateObject3, function (props) {
	return chipMixin(props);
});

var Chip = function Chip(_ref) {
	var label = _ref.label,
	    onClick = _ref.onClick,
	    actionType = _ref.actionType,
	    primary = _ref.primary,
	    success = _ref.success,
	    fill = _ref.fill,
	    color = _ref.color;

	var renderIcon = function renderIcon() {
		if (!actionType || !onClick) return null;

		var iconEl = null;
		switch (actionType) {
			case 'delete':
				iconEl = _react2.default.createElement(_Close2.default, null);
				break;
			case 'add':
				iconEl = _react2.default.createElement(_Add2.default, null);
				break;
			case 'dropdown':
				iconEl = _react2.default.createElement(_ChevronDown2.default, null);
				break;
		}

		return _react2.default.createElement(
			'span',
			{
				onClick: onClick,
				className: 'icon-btn' },
			iconEl
		);
	};

	return _react2.default.createElement(
		StyledChip,
		{
			primary: primary,
			success: success,
			filled: fill,
			color: color
		},
		_react2.default.createElement(
			'span',
			{ className: 'label' },
			label
		),
		renderIcon()
	);
};

Chip.propTypes = {
	actionType: _propTypes2.default.string,
	primary: _propTypes2.default.bool,
	success: _propTypes2.default.bool,
	fill: _propTypes2.default.bool,
	color: _propTypes2.default.string,
	onClick: _propTypes2.default.func,
	label: _propTypes2.default.string.isRequired
};

exports.Chip = Chip;